/*global $*/
/*eslint no-undef: ["error", { "typeof": true }] */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import newid from '../../utils/newid';

class Select extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: false,
      value: this.props.value
    };
    this.id = newid();
    this.handleClasses = this.handleClasses.bind(this);
    // this.handleUpdate = this.handleUpdate.bind(this);
  }

  componentDidMount() {
    $(this.refs.select).material_select();
    // Handle onchange
    $(ReactDOM.findDOMNode(this)).on('change', 'select', (e) => {
      this.props.onChange({
        target: {
          id: e.target.id,
          value: e.target.value
        }
      });
    });
  }

  // handleUpdate(e) {
  //   // I tried just sending the 'e' variable but for whatever reason
  //   // e.target.value wasn't getting sent through the callback,
  //   // so I just send the essentials here.
  //   this.setState((prevState, props) => {
  //     return {
  //       value: e.target.value
  //     };
  //   }, () => {

  //     this.props.onChange({
  //       target: {
  //         id: e.target.id,
  //         value: e.target.value
  //       }
  //     });
  //   })
  // }

  componentWillReceiveProps(nextProps) {
    let firstOption = this.props.options[Object.keys(this.props.options)[0]];

    if (nextProps.value && nextProps.value !== firstOption) {
      this.setState({ selected: true });
    } else {
      this.setState({ selected: false });
    }
  }
  
  componentDidUpdate(prevProps, prevState) {

    // if (prevProps.value !== this.props.value) {
    //   this.handleUpdate({
    //     target: {
    //       value: this.props.value,
    //       id: this.props.id
    //     }
    //   });
    // }
  }

  focus() {
    this.refs.select.focus();
  }

  handleClasses() {
    let classes = [];

    if (this.state.selected) {
      classes.push('selected');
    }

    if (this.props.value.length > 0 && this.props.valid) {
      classes.push('valid');
    }

    if (this.props.valid === false) {
      classes.push('invalid');
    }

    return classes.join(' ');
  }

  render() {
    return (
      <div className={`select input-field ${this.handleClasses()}`}>
        <select
          id={newid()}
          ref="select"
          disabled={this.props.disabled || false}
          value={this.state.value}
          onChange={e => { return true }}>
          {
            Object.keys(this.props.options).map((key) => {
              let value = this.props.options[key]
              return <option key={`${newid()}`} value={key}>{value}</option>;
            })
          }
        </select>
      </div>
    );
  }
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/Select/Select.js